import { getWindow } from "@faire/web--source/common/globals/getWindow";
export var stubImage = function(url, srcset, sizes) {
    var _getWindow;
    var ImageConstructor = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.Image;
    if (ImageConstructor && url) {
        var img = new ImageConstructor();
        img.src = url;
        if (srcset) {
            img.srcset = srcset;
        }
        if (sizes) {
            img.sizes = sizes;
        }
    }
};
